<mat-sidenav-container  class="sideNavContainer">
    <mat-sidenav #sideCart closed mode="over" >
        <app-carrello [items]="carrelloItems" [loading]="loadingCart"></app-carrello>
    </mat-sidenav> 
    <mat-sidenav-content opened="false"> 
        <app-header (toggleSideCart)="sideCart.toggle()" [items]="carrelloItems" [loading]="loadingCart"></app-header>
    </mat-sidenav-content>
</mat-sidenav-container>